import GasConsumption from "./GasConsumption";

const GasConsumptionPage = () => {
  return (
    <div>
      <GasConsumption />
    </div>
  );
};

export default GasConsumptionPage;
